module.exports = __webpack_public_path__ + "static/media/VectorMicrophone.c386514e.svg";